import { gql, useMutation } from '@apollo/client'
import { path } from 'ramda'
import { useAlert, useNotification } from '@btime/react-messager'
import React, { useState } from 'react'

import { compliancesClient, serviceOrdersClient } from '../../utils/apollo/api'
import DynamicInput from '../../components/form/DynamicInput'
import Editable from '../../packages/kiti/components/form/Editable'
import { uniqBy } from 'lodash'

const MUTATION = gql`
  mutation UpsertReplies($inputs: [ReplyInput]) {
    upsertReplies(inputs: $inputs) {
      id
    }
  }
`

const ALLOWED_TYPES = ['text', 'numeric', 'integer', 'float', 'number', 'checkbox']
const TEXT_TYPE_INPUTS = ['text', 'numeric', 'integer', 'float', 'number']

const BulkEditableReply = ({ events, children, ...props }) => {
  const modal = useAlert()
  const notify = useNotification()
  const [lastValue, setLastValue] = useState()
  const [currentValue, setCurrentValue] = useState()
  const record = events[0].reply

  const [request, { loading }] = useMutation(MUTATION, {
    refetchQueries: ['Reply', 'Replies'],
    client: serviceOrdersClient
  })

  const questionType = record.question?.typeName
  if (!record.serviceOrderId || !ALLOWED_TYPES.includes(questionType)) return children

  const prepareParams = value => {
    let inputs = events.map(event => {
      return { serviceOrderId: event.reply.serviceOrderId, questionId: event.reply.questionId, value }
    })
    return uniqBy(inputs, input => {
      return `${input.serviceOrderId}_${input.questionId}`
    })
  }

  const handleRequest = value => {
    setCurrentValue(value)
    setTimeout(() => {
      if (!modal.confirm({ title: 'Tem certeza que deseja alterar para todos?' })) {
        setCurrentValue(lastValue)
      } else {
        const params = {
          variables: { inputs: prepareParams(value) }
        }
        return request(params).then(resp => {
          if (!!resp.errors) {
            notify.error({ title: 'Ocorreu um erro ao salvar!', message: path(['errors', 0, 'message'], resp) })
          } else {
            setLastValue(value)
            compliancesClient.cache.reset()
          }
        })
      }
    }, 300)
  }

  return (
    <Editable
      value={currentValue}
      alwaysEditingVisible={true}
      onSubmit={handleRequest}
      loading={loading}
      Input={DynamicInput}
      valueType={questionType}
      submitOnChange={!TEXT_TYPE_INPUTS.includes(questionType)}
      {...props}
    >
      {children}
    </Editable>
  )
}

export default BulkEditableReply
